import { type FC } from 'react';
import { Button } from '@mantine/core';
import { useResolvePayoutTicket } from '~/entities/payout';

interface ResloveTicketProps {
    id?: string;
    onSuccess?: () => void;
    onError?: () => void;
}

export const ResolveTicket: FC<ResloveTicketProps> = ({ id, onSuccess, onError }) => {
    const { mutate, isSuccess, isPending } = useResolvePayoutTicket({ onSuccess, onError });

    const handleResolve = () => {
        mutate({
            ticketId: {
                value: id,
            },
        });
    };

    if (!id || isSuccess) {
        return null;
    }

    return (
        <Button
            onClick={handleResolve}
            disabled={isPending}
            loading={isPending}
        >
            Завершить
        </Button>
    );
};
